import ModelUtil from '@leverege/model-util'
import { parse } from 'date-fns'

const TYPE = 'imagine.operatingHours.hoursRange'

function create( options ) {
  const opts = options || {}

  return {
    type : TYPE,
    start : opts.start || '09:00AM',
    end : opts.end || '05:00PM'
  }
}

function validateTime( value, def ) {
  // null is valid
  if ( value != null ) {
    const v = parse( value, 'hh:mma', new Date() )
    if ( v?.toString() === 'Invalid Date' ) {
      return def
    }  
  }
  return undefined
}

function validateStartTime( model, key, value ) {
  return validateTime( value, '09:00am' )
}

function validateEndTime( model, key, value ) {
  return validateTime( value, '05:00pm' )
}

export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue( 'start', null, { validate : validateStartTime } ),
  ...ModelUtil.createAllValue( 'end', null, { validate : validateEndTime } )
}
